export const GENKAI_FILTERS_VALUE_LABELS = {
  mainnet: 'Ethereum',
  ronin: 'Ronin',
  locked: 'Locked',
  unlocked: 'Unlocked',
  0: 'Unrevealed',
  1: 'Revealed',
};
